import GoogleSVG from "../../assets/icons/google";
import FbSVG from "../../assets/icons/fb";
import AppleSVG from "../../assets/icons/apple";
import TwitterSVG from "../../assets/icons/twitter";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { useLeapSdk } from "../../context/sdk";
import { useEffect } from "react";
import { Box, Button } from "@mantine/core";

export default function Login() {
  const loginService = localStorage.getItem("login_service");
  const { leapSdk, user, setUser } = useLeapSdk();
  const navigate = useNavigate();
  useEffect(() => {
    if (user) {
      navigate("/", { replace: true });
    }
  }, [user]);

  const connect = async (loginOption) => {
    const res = await leapSdk.auth.connect(loginOption);
    if (loginService === "web3auth") {
      localStorage.setItem("address", res.address);
    }
    const user = await leapSdk.auth.getUser();
    setUser(
      loginService === "ramper" ? user : { ...user, address: res.address }
    );
  };
  if (!leapSdk?.auth) {
    return (
      <div className="login-container">
        <h2>Loading...</h2>
      </div>
    );
  }
  return (
    <div className="login-container">
      <div className="login-content">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: "24px",
          }}
        >
          {loginService === "ramper" ? (
            <Button
              onClick={() => {
                localStorage.setItem("auth_service", "ramper");
                connect();
              }}
              variant="outline"
              sx={{
                borderColor: "#242526",
                backgroundColor: "rgb(35, 35, 35)",
                color: "#fff",
                padding: "32px",
                height: "fit-content",
                borderRadius: "16px",
                width: "100%",
                ":hover": { backgroundColor: "rgb(35, 35, 35)" },
              }}
            >
              Login with Ramper
            </Button>
          ) : (
            <div className="login-options">
              <button onClick={() => connect("google")}>
                <GoogleSVG />
                <p>Google</p>
              </button>
              <button onClick={() => connect("facebook")}>
                <FbSVG />
                <p>Facebook</p>
              </button>
              <button onClick={() => connect("apple")}>
                <AppleSVG />
                <p>Apple</p>
              </button>
              <button onClick={() => connect("twitter")}>
                <TwitterSVG />
                <p>Twitter</p>
              </button>
            </div>
          )}
        </Box>
      </div>
      <div className="footer-links">
        <Link to="/">Terms of use</Link>
        <Link to="/">Privacy Policy</Link>
        <Link to="/">Support</Link>
        <Link to="/">About us</Link>
      </div>
    </div>
  );
}
